import React from "react";

const sagar_satbhai = () => {
  return (
    <div>
      <h1>Sagar Satbhai</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />- A total of 107 candidates registered for the internship
        process, out of which 67 were shortlisted based on their resumes. The
        shortlisted students were considered for three roles: C++ Developer,
        DevEx (Python), and QA (Python).{" "}
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />- The first round, an aptitude test, was conducted on September
        19. A total of 18 students were shortlisted for the interview round,
        which was held offline on September 28. Finally, a Online Cultural
        Fitness Assessment was conducted on September 30.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />- The aptitude round was structured with two coding questions and
        ten multiple-choice questions based on C++. The total duration of the
        test was one hour.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />- In the C++ domain, 18 students were shortlisted after the
        aptitude round to appear for the offline interview
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        - The shortlist was released three days before the interviews, but I
        began preparing immediately after the aptitude round. During this
        period, I focused on important C++ concepts such as Object-Oriented
        Programming (OOP), multithreading, and the practical applications of OOP
        principles. I also reviewed my resume thoroughly and revised key
        concepts from DBMS.
        <br />
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />- There were two interview rounds{" "}
      </p>

      <ol>
        <li>Technical round – 18 shortlisted </li>
        <li>Cultural Fitness Assessment - 1 students shortlisted</li>
      </ol>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />- The interview primarily focused on C++ concepts, especially
        Object-Oriented Programming (OOP) topics such as virtual classes,
        inheritance, and pointers. In addition, I was asked to solve one Data
        Structures and Algorithms (DSA) question, which involved detecting a
        loop in a linked list. Overall, the questions mainly revolved around
        core OOP principles and pointer concepts in C++.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        - DSA - Strivers A2Z Sheet
        <br />
        DBMS - Notes by CodeHelp by LoveBabbar
        <br />
        C++ - GFG articles, YOUTUBE videos of code with harry.
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />- keep solving the dsa questions on leetcode , codeforces etc
        platforms
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        - Surprisingly, no questions were asked about projects, clubs, or
        extracurricular activities.
        <br />
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />- The company mainly prefers C++ as the primary language for
        coding.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />- Focus on solving DSA questions, and keep revisiting the concepts
        of OOP and DBMS regularly.
      </p>

      <p>
        <strong>Contact Info</strong>
        <br />
        <strong>Phone No :</strong> 9322741285
        <br />
        <strong>Email :</strong> <a href="mailto:sagarsatbhai2010@gmail.com">sagarsatbhai2010@gmail.com</a>
        <br />
        <strong>LinkedIn :</strong>{" "}
        <a href="http://www.linkedin.com/in/sagar-satbhai-7974ba292">
          Sagar Satbhai
        </a>
      </p>
    </div>
  );
};

export default sagar_satbhai;
